/**
 * Campos permitidos para edição no fluxo "Corrigir e reimprimir" a partir da
 * aba de Retiradas (INFORMACP-4388).
 *
 * Whitelist rígida alinhada ao backend (edit-form / edit-reprint):
 *   - credentialName (nome na credencial)
 *   - companyName    (empresa)
 *   - jobTitle       (cargo)
 *
 * Documento NÃO é editável nem impresso neste fluxo.
 *
 * `promotable` indica se o campo pode ser promovido à fonte quando o atendente
 * marca "salvar no cadastro" (promoteToSource): apenas credentialName e jobTitle.
 * A empresa (companyName) é sempre pontual — nunca é persistida na fonte por aqui.
 *
 * Contrato de cada campo:
 *  - key       : nome do campo no formulário (== apiKey enviado ao backend)
 *  - apiKey    : nome esperado pelo backend
 *  - labelId   : id da mensagem i18n (react-intl)
 *  - promotable: se participa da promoção à fonte
 */
export const EDITABLE_CREDENTIAL_FIELDS = [
  {
    key: "credentialName",
    apiKey: "credentialName",
    labelId: "credential_name",
    promotable: true,
  },
  {
    key: "companyName",
    apiKey: "companyName",
    labelId: "company_name_credential",
    promotable: false,
  },
  {
    key: "jobTitle",
    apiKey: "jobTitle",
    labelId: "assignment",
    promotable: true,
  },
];

export const getEnabledEditableFields = () => EDITABLE_CREDENTIAL_FIELDS;

export default EDITABLE_CREDENTIAL_FIELDS;
